import { render } from "./SocialBar.vue?vue&type=template&id=91e21ff2"
import script from "./SocialBar.vue?vue&type=script&lang=js"
export * from "./SocialBar.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__